__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "HER";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations", "20.3.19", () => (__webpack_require__.e(900).then(() => (() => (__webpack_require__(6900))))));
			register("@angular/common/http", "20.3.19", () => (__webpack_require__.e(891).then(() => (() => (__webpack_require__(9891))))));
			register("@angular/common", "20.3.19", () => (__webpack_require__.e(412).then(() => (() => (__webpack_require__(9412))))));
			register("@angular/core/rxjs-interop", "20.3.19", () => (__webpack_require__.e(634).then(() => (() => (__webpack_require__(3634))))));
			register("@angular/core", "20.3.19", () => (__webpack_require__.e(732).then(() => (() => (__webpack_require__(6732))))));
			register("@angular/forms", "20.3.19", () => (__webpack_require__.e(584).then(() => (() => (__webpack_require__(6584))))));
			register("@angular/platform-browser", "20.3.19", () => (__webpack_require__.e(870).then(() => (() => (__webpack_require__(6870))))));
			register("@angular/router", "20.3.19", () => (__webpack_require__.e(198).then(() => (() => (__webpack_require__(7198))))));
			register("@azure/msal-angular", "5.2.2", () => (__webpack_require__.e(707).then(() => (() => (__webpack_require__(5707))))));
			register("@azure/msal-browser", "5.9.0", () => (__webpack_require__.e(156).then(() => (() => (__webpack_require__(4156))))));
			register("@idb/designsystem", "2.8.0", () => (__webpack_require__.e(977).then(() => (() => (__webpack_require__(7977))))));
			register("@oper/common", "2.1.0", () => (__webpack_require__.e(873).then(() => (() => (__webpack_require__(8873))))));
			register("rxjs", "7.8.2", () => (__webpack_require__.e(843).then(() => (() => (__webpack_require__(5843))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};